import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { authAPI } from '@/api/new-api'
import { UPDATE_BUILDING } from '@/reducers/buildingSelectorReducer'
import { Building } from '@/reducers/types'
import { composeFormData } from '@/utils'

export interface UpdateBuildingRequest {
  data: Record<string, unknown>
  id: number
  // Note: send JSON instead of multipart - needed for array fields the backend stores as JSON
  // (`availableLocale`): multipart turns an array into a string, which is then stored as a string.
  // No files can be sent this way.
  json?: boolean
}

export const updateBuilding = async ({ data, id, json }: UpdateBuildingRequest) => {
  if (json) {
    const response = await authAPI.put<Building>(`/building/${id}`, data)
    return response.data
  }

  const response = await authAPI.put<Building>(`/building/${id}`, composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

// Note: the building list and the active building live in Redux (navbar, feature gating), not in React Query
export const useUpdateBuilding = () => {
  const dispatch = useDispatch()

  return useMutation({
    mutationFn: updateBuilding,
    onSuccess: (building) => {
      dispatch({ buildingData: building, type: UPDATE_BUILDING })
    },
  })
}
